import ActiveModel from '@/util/v01/ActiveModel';

export default class Survey extends ActiveModel { 
    static backend = '/survey/jilid/';           

    static entity = 'survey';    
    
    static fields () {
        return {
            id: this.attr(null),
            name: this.attr(''),
            description: this.attr(''),
            color: this.attr(''),
            node_id: this.attr(''),
            status: this.attr(1),
            created_at: this.attr(null),
            created_by: this.attr(null),
            updated_at: this.attr(null),
            updated_by: this.attr(null),
            lembar: this.attr(null),
            node: this.attr({}),
            counting: this.attr({}),
            quetionnaires: this.attr([]),
        }
    }
    
    static jilids(params={}){           
      return this.api.get(this.backend+'index', params).then(res => {                                    
        return res.status == 200 ? res.data : {data : Survey.all(), pagination:{}};
      });
    }   

    static jilid(params={}){
      return this.api.get(this.backend+'view', params).then(res => {          
        return res.status == 200 ? res.data : {};
      });
    }

    static nodes(params={}){
      return this.api.get('/master/node/index', params).then(res => {          
          return res.status == 200 ? res.data : {};
      });
    }

    static node(params={}){
      return this.api.get('/master/node/view', params).then(res => {          
          return res.status == 200 ? res.data : {};
      });
    }    
}

